/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseVideoTutorial } from '../../models/api-response-video-tutorial';
import { VideoTutorial } from '../../models/video-tutorial';

export interface CreateVideoTutorial$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: VideoTutorial
}

export function createVideoTutorial(http: HttpClient, rootUrl: string, params: CreateVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVideoTutorial>> {
  const rb = new RequestBuilder(rootUrl, createVideoTutorial.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseVideoTutorial>;
    })
  );
}

createVideoTutorial.PATH = '/v1/api/admin-ui/video-tutorial/create';
